import { render } from "./CatFact.vue?vue&type=template&id=6e02ca33"
import script from "./CatFact.vue?vue&type=script&lang=js"
export * from "./CatFact.vue?vue&type=script&lang=js"

import "./CatFact.vue?vue&type=style&index=0&id=6e02ca33&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__